/*
* @描述: 报价单下载
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-15 17:58:41
*/
<template>
    <el-dialog
            :before-close="handleDialogClose"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            custom-class="quotation_download_dialog"
            title="报价单打印"
            width="1054px">
        <div id="print_content" v-loading="loading" class="quotation_download_wrap">
            <TemplateComponent v-if="dataLoaded"
                               ref="templateComponent"
                               :fields_list="quotation_fields_list"
                               :project_quotation_tmpl_form="quotation_tmpl_form"
                               :quotation_detail="quotation_detail"
                               :templateType="'detail'"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="handleDialogClose">取消</el-button>
            <el-button size="small" type="primary" @click="handleClickPrint">打印</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {projectQuotationDetail, projectQuotationPrint} from "@/api";
    import TemplateComponent from "@/views/pc/Business/component/template_component_detail";
    import print from 'print-js'

    export default {
        name: "quotationPrintDialog",
        data() {
            return {
                quotation_tmpl_form: '',
                quotation_detail: {},
                quotation_fields_list: [],
                dataLoaded: false,
                loading: false,
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            quotation_id: {
                type: Number,
                default: 0,
            },
        },
        created() {
            this.loading = true
            projectQuotationDetail({
                project_quotation_id: this.quotation_id
            }).then(res => {
                if (res.code === 200) {
                    this.quotation_tmpl_form = res.data.project_quotation_tmpl_form
                    this.quotation_detail = res.data
                    this.quotation_fields_list = res.data.custom_fields
                    this.dataLoaded = true
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        mounted() {
        },
        components: {TemplateComponent},
        methods: {
            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },

            handleClickPrint() {
                setTimeout(() => {
                    print({
                        printable: 'print_content', // 要打印的元素的 ID
                        type: 'html', // 打印类型为 HTML
                        documentTitle: this.quotation_detail.title, // 打印文档的标题
                        targetStyles: ['*'], // 也可以包含样式
                    })
                }, 500)
                /*projectQuotationPrint({
                    project_quotation_id: this.project_quotation_id
                }).then(res => {
                    if (res.code === 200) {
                    } else {
                        this.$message.error(res.message)
                    }
                })*/
            },
        },
    }
</script>
<style lang="scss">
    .quotation_download_dialog {
        height: 80vh;
        display: flex;
        flex-direction: column;

        .el-dialog__body {
            flex: 1;
            overflow-y: auto;
        }

        .quotation_download_wrap {
            height: 100%;
        }
    }
</style>